/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Spacer, theme } from "@nordcloud/gnui";
import {
  SortOrder,
  PastActionsForResourceSortFields,
} from "~/generated/graphql";
import { TableSearchInput } from "~/components/SearchInput";
import { SortSelector } from "~/components/SortSelector";
import { useQueryState } from "~/hooks";
import { ResourceDetailsActionsQuery } from "../../types/ResourceDetailsActionsQuery";
import { ResourceDetailsActionsFiltersSidebar } from "./ResourceDetailsActionsFiltersSidebar";

const sortOptions = [
  {
    value: PastActionsForResourceSortFields.Status,
    label: "Resource Status",
  },
  {
    value: PastActionsForResourceSortFields.ActionName,
    label: "Action Name",
  },
  {
    value: PastActionsForResourceSortFields.ResourceGroupName,
    label: "Resource Group Name",
  },
  {
    value: PastActionsForResourceSortFields.EventName,
    label: "Event Name",
  },
  {
    value: PastActionsForResourceSortFields.EndTime,
    label: "End Time",
  },
];

export function ResourceDetailsActionsTableHeader({
  resultsCount = 0,
}: {
  resultsCount?: number;
}) {
  const { queryState, updateQueryState } =
    useQueryState<ResourceDetailsActionsQuery>();

  const handleSortDirection = (order: SortOrder) => {
    updateQueryState({
      ...queryState,
      order,
    });
  };

  const handleSortField = (field: PastActionsForResourceSortFields) => {
    updateQueryState({
      ...queryState,
      field,
    });
  };

  const handlePhraseField = (field: string | undefined) => {
    updateQueryState({
      ...queryState,
      searchPhrase: field,
    });
  };

  return (
    <>
      <SortSelector<PastActionsForResourceSortFields>
        options={sortOptions}
        value={queryState.field ?? PastActionsForResourceSortFields.EndTime}
        direction={queryState.order ?? SortOrder.Desc}
        onSelect={handleSortField}
        onSortChange={handleSortDirection}
      />
      <Spacer width={theme.spacing.spacing04} />
      <TableSearchInput<ResourceDetailsActionsQuery>
        onSubmit={handlePhraseField}
        placeholder="Type a Keyword (e.g. Action Name, Resource Group Name, etc.)"
      />
      <Spacer width={theme.spacing.spacing04} />
      <ResourceDetailsActionsFiltersSidebar resultsCount={resultsCount} />
    </>
  );
}
